import React, {useState} from 'react';
import {VersionModal} from "../modal/VersionModal";

export const MainFooter = ({userService, eventService, __env}) => {
  const frontendVersion = __env.frontendVersion || "1.12.20";
  const currentYear = new Date().getFullYear();
  const [seeVersions, setSeeVersions] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  eventService.on('update-rights', () => {
    setSeeVersions(userService.hasServiceVersions());
  });

  return (
    <>
      <footer className="main-footer">
        <div className="footer-wrapper">
          <span>Copyright © 2020-{currentYear} EKE-Electronics Ltd.</span>
          {seeVersions && <span>SmartVision™ version <button className={"link"}
                                              onClick={toggleModal}>{frontendVersion}</button></span>}
          {!seeVersions && <span>SmartVision™ version {frontendVersion}</span>}
          <span>
            <a 
              href="https://www.eke-electronics.com/" 
              target="_blank" 
              rel="noopener noreferrer">
                www.eke-electronics.com
            </a>
          </span>
          <span>
            <a 
              href="/oss-attribution">
                Open Source Licenses
            </a>
          </span>
        </div>
      </footer>
      {seeVersions && <VersionModal open={modalOpen} toggle={toggleModal} frontendVersion={frontendVersion}/>}
    </>
  )
};